(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSelectNetworks(
    NetworkListService, $timeout, TenantListService
  ) {
    return {
      restrict: 'EA',
      scope: {
        paginationObject: '=paginationObject',
        toggleNetwork: '&toggleNetwork',
        exceptions: '=exceptions',
        callback: '&callback'
      },
      templateUrl: 'app/components/onDeviceConfigProperties/selectNetwork/selectNetwork.template.html',
      link: function(scope) {

        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';

        if (scope.exceptions) {
          if (scope.exceptions.overlap) {
            angular.element('.paginated-flyout').css({left: 210});
          }
        }

        (function() {
          getFirstPage();
        })();

        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 20;
          scope.list = [];
          scope.loadingPage = true;
          NetworkListService.getNetworkListPaged(scope.paginationObject).then(function(networks) {


            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = networks.page.totalPages;
            if (networks.list) {
              scope.list = networks.list;
            }
          }).catch(function(error) {});
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          $timeout(function () {
            getFirstPage();
          }, 500)
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            NetworkListService.getNetworkListPaged(scope.paginationObject).then(function(networks){

              if (networks.list) {
                scope.list = scope.list.concat(networks.list);
              }
              scope.loadingPage = false;
            }).catch(function(error) {});
          }
        }

        angular.element('.paginated-flyout-list').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.pagination-small-results').off('scroll');
        });

        // scope.selectItem = function (event, selectedItem) {
        //   event.stopPropagation();
        //   scope.callback({selectedItem: selectedItem})
        // }

        scope.closePopup = function (event) {
          scope.callback();
        }

        scope.closePopupOutside = function (event) {
          if (scope.exceptions.closeOutside) {
            scope.callback();
          }
        }




        scope.selectNetwork = function(network, event) {
          event.stopPropagation();
          if (scope.exceptions.closeOnSelect) {
            scope.callback({network: network})
          } else {
            scope.toggleNetwork({network: network});
          }
        }





      }
    };
  }

  pxSelectNetworks.$inject = ['NetworkListService', '$timeout', 'TenantListService'];

  angular
    .module('printix-admin')
    .directive('pxSelectNetworks', pxSelectNetworks);

})();
